module.exports = __webpack_public_path__ + "static/media/ChartDown.18cd9247.svg";